import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import CloseIcon from '@mui/icons-material/Close'
import TemplatePreviewBox from '../../components/TemplatePreviewBox'
import { TEMPLATE_CHANNELS } from '../../consts'

const TemplatePreview = ({ template, onClose, onOpenFull }) => {
  if (!template) return null

  const channelLabel =
    TEMPLATE_CHANNELS.find((ch) => ch.value === template.channel)?.label ||
    template.channel

  return (
    <Dialog open={!!template} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block', mb: 0.5 }}
            >
              Preview
            </Typography>
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}
            >
              <Typography variant="h6">{template.name}</Typography>
              <Chip label={channelLabel} size="small" variant="outlined" />
            </Box>
            {template.description && (
              <Typography variant="body2" color="text.secondary">
                {template.description}
              </Typography>
            )}
          </Box>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              bgcolor: 'action.hover',
              width: 28,
              height: 28,
              ml: 2,
              '&:hover': {
                bgcolor: 'action.selected',
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <TemplatePreviewBox
          subject={template.subjectTemplate}
          body={template.bodyTemplate}
          channel={template.channel}
        />
        <Divider sx={{ my: 2 }} />
        <Typography variant="caption" color="text.secondary">
          Variables shown with sample data
        </Typography>
      </DialogContent>
      {onOpenFull && (
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            size="small"
            startIcon={<OpenInNewIcon fontSize="small" />}
            onClick={onOpenFull}
          >
            Open template for editing
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default TemplatePreview
